import { render, staticRenderFns } from "./PGOApps.vue?vue&type=template&id=d3001b56&scoped=true"
import script from "./PGOApps.vue?vue&type=script&lang=js"
export * from "./PGOApps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3001b56",
  null
  
)

export default component.exports